"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDirectionalLight = exports.createHemisphereLight = exports.createAmbientLight = void 0;
const three_1 = require("three");
function createAmbientLight(color = 0xffffff, intensity = 1) {
    /**
     * Cheapest way of faking indirect lighting in three.js. This type of light adds
     * a constant amount of light from every direction to every object in the scene.
     * It doesn’t matter where you place this light and it doesn’t matter where other
     * objects are placed relative to the light. This is not at all similar to how
     * light in the real world works. Nonetheless, in combination with one or more
     * direct lights, it gives OK results.
     */
    const ambientLight = new three_1.AmbientLight(color, intensity);
    return ambientLight;
}
exports.createAmbientLight = createAmbientLight;
function createHemisphereLight(skyColor = 0xffffff, groundColor = 0x444444, intensits = 1) {
    /**
     * Light from a HemisphereLight fades between a sky color at the top of the scene
     * and a ground color at the bottom of the scene. Like the AmbientLight, this light
     * makes no attempt at physical accuracy. Rather, the HemisphereLight was created
     * after observing that in many of the situations where you find humans, the brightest
     * light comes from the top of the scene, while light coming from the ground is
     * usually less bright.
     */
    const hemisphereLight = new three_1.HemisphereLight(skyColor, // bright sky color
    groundColor, // dim ground color
    intensits // intensity
    );
    return hemisphereLight;
}
exports.createHemisphereLight = createHemisphereLight;
function createDirectionalLight(color = 0xffffff, intensity = 5, position = new three_1.Vector3(0, 1, 0)) {
    /**
     * A single bright DirectionalLight can represent the sun.
     */
    const directionalLight = new three_1.DirectionalLight(color, // color
    intensity // intensity
    );
    directionalLight.position.set(position.x, position.y, position.z);
    return directionalLight;
}
exports.createDirectionalLight = createDirectionalLight;
